@if (data.rawOrderItem) {
  <h1 mat-dialog-title>
    {{
    data.rawOrderItem.medicine_dosage_package_type.label_name ? data.rawOrderItem.medicine_dosage_package_type.label_name : '-'
    }}
    -
    {{
    data.rawOrderItem.medicine_dosage_package_type.medicine_dosage_type ? data.rawOrderItem.medicine_dosage_package_type.medicine_dosage_type.additional_information : '-'
    }}
  </h1>
  <div mat-dialog-content>
    <table mat-table matSort [dataSource]="batchItems" class="w-100">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let item"> {{ item.id }} </td>
      </ng-container>
      <ng-container matColumnDef="barcode">
        <th mat-header-cell *matHeaderCellDef>Barcode</th>
        <td mat-cell *matCellDef="let item"> {{item.barcode ? item.barcode : '-'}} </td>
      </ng-container>
      <ng-container matColumnDef="medicine_number">
        <th mat-header-cell *matHeaderCellDef>Medicine number</th>
        <td mat-cell *matCellDef="let item">
          {{data.rawOrderItem.medicine_dosage_package_type.medicine_dosage_type ? data.rawOrderItem.medicine_dosage_package_type.medicine_dosage_type.medicine_number : '-'}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
}

@if (data.orderItem) {
  <h1 mat-dialog-title>
    {{
    data.orderItem.medicineDosagePackageType.label_name ? data.orderItem.medicineDosagePackageType.label_name : '-'
    }}
    -
    {{
    data.orderItem.dosageType ? data.orderItem.dosageType.additional_information : '-'
    }}
  </h1>
  <div mat-dialog-content>
    <table mat-table matSort [dataSource]="batchItems" class="w-100">
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let item"> {{ item.id }} </td>
      </ng-container>
      <ng-container matColumnDef="barcode">
        <th mat-header-cell *matHeaderCellDef>Barcode</th>
        <td mat-cell *matCellDef="let item"> {{item.barcode ? item.barcode : '-'}} </td>
      </ng-container>
      <ng-container matColumnDef="medicine_number">
        <th mat-header-cell *matHeaderCellDef>Medicine number</th>
        <td mat-cell *matCellDef="let item">
          {{data.orderItem.medicineDosagePackageType.medicine_dosage_type.medicine_number ? data.orderItem.medicineDosagePackageType.medicine_dosage_type.medicine_number : '-'}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
}

<div mat-dialog-actions align="end">
  <button mat-raised-button color="primary" (click)="closeDialog()">
    Close
  </button>
</div>